<div class="flex flex-col" *transloco="let t">
    <div class="flex flex-row relative mb-4">
        <h1> {{ t('user-profile-title')}}</h1>
        <button class="absolute right-0" mat-button (click)="dialogRef?.close()" *ngIf="dialogRef && !disableClose">X</button>
    </div>
    <div cdkScrollable>
        <div class="profile-scroll">
            <form [formGroup]="userForm" class="p-4 bg-card grid grid-cols-1 sm:grid-cols-2 gap-x-6 items-start">
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>{{ t('user-profile-firstname')}}</mat-label>
                    <input matInput [placeholder]="user?.firstName" [formControlName]="'firstName'">
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>{{ t('user-profile-lastname')}}</mat-label>
                    <input matInput [placeholder]="user?.lastName" [formControlName]="'lastName'">
                </mat-form-field>

                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>{{ t('user-profile-company')}}</mat-label>
                    <input matInput [placeholder]="user?.company" [formControlName]="'company'">
                </mat-form-field>

                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>{{ t('user-profile-email')}}</mat-label>
                    <input matInput [placeholder]="user?.email" [formControlName]="'email'" [readonly]="true">
                </mat-form-field>

                <mat-checkbox [formControlName]="'useCustomBillingEmail'"
                              (change)="onBillingEmailToggle($event.checked)"
                              class="my-2 sm:col-span-2">{{ t('user-profile-billing-email-toggle')}}</mat-checkbox>

                <mat-form-field appearance="fill" class="w-full sm:col-span-2" *ngIf="hasCustomBillingEmail">
                    <mat-label>{{ t('user-profile-billing-email')}}</mat-label>
                    <input matInput type="email" [formControlName]="'billingEmail'">
                    <mat-hint>{{ t('user-profile-billing-email-hint')}}</mat-hint>
                    <mat-error>{{ t('user-profile-billing-email-error')}}</mat-error>
                </mat-form-field>

                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>{{ t('user-profile-phonenumber')}}</mat-label>
                    <input matInput [placeholder]="user?.phoneNumber" [formControlName]="'phoneNumber'">
                </mat-form-field>

                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>{{ t('user-profile-date-of-birth')}}</mat-label>
                    <input matInput [matDatepicker]="picker" [formControlName]="'dateOfBirth'" [max]="maxBirthDate">
                    <mat-hint>DD.MM.YYYY</mat-hint>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>

                <ng-container formGroupName="address">
                    <mat-form-field appearance="fill" class="w-full">
                        <mat-label>{{ t('user-profile-address-street')}}</mat-label>
                        <input matInput [placeholder]="user?.address?.street" [formControlName]="'street'">
                    </mat-form-field>
                    <mat-form-field appearance="fill" class="w-full">
                        <mat-label>{{ t('user-profile-address-housenumber')}}</mat-label>
                        <input matInput [placeholder]="user?.address?.houseNumber"
                               [formControlName]="'houseNumber'">
                    </mat-form-field>
                    <mat-form-field appearance="fill" class="w-full">
                        <mat-label>{{ t('user-profile-address-city')}}</mat-label>
                        <input matInput [placeholder]="user?.address?.city" [formControlName]="'city'">
                    </mat-form-field>
                    <mat-form-field appearance="fill" class="w-full">
                        <mat-label>{{ t('user-profile-address-postalcode')}}</mat-label>
                        <input matInput [placeholder]="user?.address?.postalCode" [formControlName]="'postalCode'">
                    </mat-form-field>
                    <mat-form-field appearance="fill" class="w-full">
                        <mat-label class="text-white">{{ t('user-profile-address-country')}}</mat-label>
                        <mat-select [formControlName]="'country'">
                            <mat-option *ngFor="let country of countryValues" [value]="country?.code">
                                {{t(country?.name)}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </ng-container>
            </form>
        </div>
        <div mat-dialog-actions class="flex flex-col sm:flex-row gap-2">
            <button class="fuse-mat-button-rounded mb-4 w-full sm:w-auto" mat-flat-button [color]="'primary'" (click)="save()"
                    [disabled]="userForm?.disabled || userForm?.invalid">{{
                t('user-profile-save-button')}}</button>

            <button class="fuse-mat-button-rounded mb-4 w-full sm:w-auto" mat-flat-button [color]="'secondary'"
                    (click)="deleteAccount()" *ngIf="showDeleteButton">{{
                t('user-profile-delete-button')}}</button>
        </div>

    </div>
</div>
